/**
 * Best-effort OS detection from the user agent. Order matters: 'mac' is
 * checked before 'win' so strings like "darwin" can never read as Windows.
 * iPadOS in desktop mode reports as Mac — acceptable for download CTAs.
 */
export type DetectedOS = 'mac' | 'windows' | 'other';

export function detectOS(): DetectedOS {
  const ua = navigator.userAgent.toLowerCase();
  if (ua.includes('mac')) return 'mac';
  if (ua.includes('win')) return 'windows';
  return 'other';
}
